import Axios from 'axios'
import { message } from 'antd'
import _ from 'lodash'

const successCode = ['200', 200, 0, '0', 'ok', 'true']

const handle401 = _.debounce(() => {
  // 避免多次弹窗
  message.error('您的登录状态已过期，请重新登录')
  setTimeout(() => {
    window.location.href = `/webapp/login?redirect=${location.pathname + location.search}`
  }, 1000)
}, 100)

// 请求失败后的错误统一处理
const netErrorHandle = (status: any, msg: any) => {
  switch (status) {
    case 401:
      handle401()
      break
    case 403:
      message.error(`服务器异常${status}`)
      break
    case 404:
      message.error(`服务器异常${status}`)
      break
    case 406:
      message.error(`服务器异常${status}`)
      break
    default:
      message.error(`服务器异常${status}`)
      console.log(msg, 'msg')
  }
}

// 创建axios实例
const instance = Axios.create({ timeout: 3000 })

/**
 * 请求拦截器
 * 每次请求前，如果存在token则在请求头中携带token
 */

instance.interceptors.request.use(
  (config) => {
    const token = '' // 获取token
    token && (config.headers.Authorization = token)
    config.withCredentials = true
    return config
  },
  (error) => Promise.reject(error)
)

/**
 * 响应拦截器
 * 拦截响应并统一处理
 */

instance.interceptors.response.use(
  (res: any) => {
    if (res.status && res.status === 200 && (successCode.indexOf(res.data.status) > -1 || successCode.indexOf(res.data.code) > -1)) {
      return Promise.resolve(res.data)
    } else {
      const data = res.data || {}
      const msg = data.msg || data.message
      // 业务状态码 token过期，这里后端应该走http状态吗，不应该走业务状态码
      if (data.status === '401001') {
        netErrorHandle(401, msg)
      } else {
        message.error(msg || '操作失败')
      }
      return Promise.reject(res)
    }
  },
  (error) => {
    const { response, message: msg } = error
    if (response) {
      netErrorHandle(response.status, response.data.message)
      return Promise.reject(response)
    } else {
      console.warn(msg)
      if (msg && msg.indexOf('timeout') > -1) {
        message.error('请求超时，请稍后重试')
        return Promise.reject(error)
      } else if (!window.navigator.onLine) {
        // 通知断网
        message.error('请求失败，请检查您的网络连接情况')
        return Promise.reject(error)
      } else {
        return Promise.reject(error)
      }
    }
  }
)

export default instance
